import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-24" }
const _hoisted_2 = { class: "row gx-48 mb-64" }
const _hoisted_3 = {
  key: 0,
  class: "col-6"
}
const _hoisted_4 = { class: "professionals-consultations" }
const _hoisted_5 = { class: "h4 title text-primary mb-32" }
const _hoisted_6 = { class: "fw-normal" }
const _hoisted_7 = { class: "footer" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-view-light me-8",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_9 = {
  key: 1,
  class: "col-6"
}
const _hoisted_10 = { class: "h4 title text-primary mb-32" }
const _hoisted_11 = { class: "fw-normal" }
const _hoisted_12 = { class: "footer" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-view-light me-16",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "row"
}
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = { class: "h4 title text-primary mb-32" }
const _hoisted_17 = { class: "fw-normal" }
const _hoisted_18 = { class: "row mb-64" }
const _hoisted_19 = { class: "h4 title text-primary mb-16" }
const _hoisted_20 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_patient_consultations = _resolveComponent("v-patient-consultations")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_the_patient_general_authorizations = _resolveComponent("the-patient-general-authorizations")!
  const _component_the_patient_expedient_measures_list = _resolveComponent("the-patient-expedient-measures-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.can('patient.expedient.consultation.index'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h2", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('Últimas')), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('consultas')), 1)
                ]),
                _createVNode(_component_v_patient_consultations, {
                  class: "mb-24",
                  consultations: _ctx.consultations,
                  "show-consultation": true,
                  "go-show-consultation": true
                }, null, 8, ["consultations"]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_router_link, {
                    to: {name: 'patient.expedient.show', params: {
              expedient:  _ctx.currentExpedient.id,
              tabName: 'consultas',
              treatment: _ctx.$route.params.treatment,
              consultation: _ctx.$route.params.consultation
            },
            query: {
              tratamiento: _ctx.currentTreatment?.id,
            }},
                    class: "btn btn-secondary btn-sm me-16 mb-12",
                    "aria-label": _ctx.$t('Ver todas las consultas')
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('Ver todas las consultas')), 1)
                    ]),
                    _: 1
                  }, 8, ["to", "aria-label"])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.can('patient.expedient.purchase-authorization.index'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("h2", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('Últimas')), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('autorizaciones')), 1)
              ]),
              _createVNode(_component_the_patient_general_authorizations),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_router_link, {
                  to: {name: 'patient.expedient.show', params: {
              expedient:  _ctx.currentExpedient.id,
              tabName: 'autorizacion-compra',
              treatment: _ctx.$route.params.treatment,
              consultation: _ctx.$route.params.consultation
            },
            query: {
              tratamiento: _ctx.currentTreatment?.id,
            }},
                  class: "btn btn-secondary btn-sm me-16 mb-12",
                  "aria-label": _ctx.$t('Ver todas las autorizaciones')
                }, {
                  default: _withCtx(() => [
                    _hoisted_13,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('Ver todas las autorizaciones')), 1)
                  ]),
                  _: 1
                }, 8, ["to", "aria-label"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.can('professional.expedient.treatment.index'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("h2", _hoisted_16, [
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('Histórico')), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('Tratamientos')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("h2", _hoisted_19, _toDisplayString(_ctx.$t('Medidas')), 1),
      (!_ctx.can('patient.expedient.measures.form.index'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.$t('No tienes permisos para ver las medidas')), 1))
        : (_openBlock(), _createBlock(_component_the_patient_expedient_measures_list, { key: 1 }))
    ])
  ], 64))
}